import { FC, Fragment, useState } from "react";
import { Stack } from "@mui/material";
import { useEffectOnceWhen } from "rooks";
import { useFlag } from "@unleash/proxy-client-react";
import { DimensionDrawerHeader } from "./DimensionDrawerHeader";
import { DimensionStatusAlert } from "./DimensionStatusAlert";
import { DimensionName } from "./DimensionName";
import { DimensionFormActions } from "./DimensionFormActions";
import { AddCategoryButton } from "../categories/AddCategoryButton";
import { DimensionsCategoriesList } from "../categories/DimensionsCategoriesList";
import { CategorySharedCostTabType } from "@/components/pages/dimensions/components/form-drawer/components/dimension/category-cost-allocation-tabs/CategoryCostAllocationTabItem";
import { CategoryCostAllocationTabs } from "@/components/pages/dimensions/components/form-drawer/components/dimension/category-cost-allocation-tabs/CategoryCostAllocationTabs";
import { DimensionCostAllocationsList } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/DimensionCostAllocationsList";
import { AddAllocationRuleButton } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/AddAllocationRuleButton";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { initializeSharedCostsThunk } from "@/store/dimensions/thunks/shared-costs/initializeSharedCostsThunk";
import { dimensionDrawerModeSelector } from "@/store/dimensions/selectors/slice-data/dimensionDrawerModeSelector";

interface DimensionDrawerFormProps {
  onClose(): void;
  onSave?(): void;
}

export const DimensionDrawerForm: FC<DimensionDrawerFormProps> = ({
  onClose,
  onSave,
}) => {
  const enableDimensionsSharedCosts = useFlag("EnableDimensionsSharedCosts");
  const dispatch = useAppDispatch();
  const mode = useAppSelector(dimensionDrawerModeSelector);

  const [view, setView] = useState<CategorySharedCostTabType>("category");

  useEffectOnceWhen(() => {
    dispatch(initializeSharedCostsThunk());
  }, mode === "dimensionEdit");

  return (
    <Fragment>
      <DimensionDrawerHeader onClose={onClose} />

      <Stack spacing={2} p={2} bgcolor="grey.100">
        <DimensionStatusAlert />

        <DimensionName />

        {enableDimensionsSharedCosts && (
          <CategoryCostAllocationTabs view={view} setView={setView} />
        )}

        {view === "category" && (
          <Fragment>
            <DimensionsCategoriesList />
            <AddCategoryButton />
          </Fragment>
        )}

        {view === "sharedCost" && (
          <Fragment>
            <DimensionCostAllocationsList />
            <AddAllocationRuleButton />
          </Fragment>
        )}
      </Stack>

      <DimensionFormActions onClose={onClose} onSave={onSave} />
    </Fragment>
  );
};
